module.exports = __webpack_public_path__ + "media/react/marketing/pages/home/toefl/sections/apps/assets/prep_app-c88a55ee611349b9c12969ae7158a9ed.png";